  import React, { useState, useEffect, createContext, useRef }from 'react';
  import axios from "axios";
  import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
  import '../../App.css';
  import '../styles/Sidebar.css'
  import PrivateRoute from './PrivateRoute';
  import SingleRequest from './SingleRequest';
  import SingleUser from './SingleUser';
  import MenuSettings from './MenuSettings';
  import Sidebar from "./Sidebar";
  import Logout from './Logout';
  import InfoPoliciesGuidelines from './InfoPoliciesGuidelines';
  import InfoAbout from './InfoAbout';
  import Overview from './Overview';
  import OviewMain from './OviewMain';
  import OviewReports from './OviewReports';
  import OviewTasks from './OviewTasks';
  import OviewTeam from './OviewTeam';
  import Documents from './Documents';
  import Transactions from './Transactions'
  import FormRequest from './FormRequest';
  import MgmtRequests from './MgmtRequests';
  import MgmtUsers from './MgmtUsers'
  import NltxEmployees from './NltxEmployees'
  import NltxClients from './NltxClients'
  import NltxTransactions from './NltxTransactions'
  import NltxDocuments from './NltxDocuments'

  export const SidebarStateContext = createContext();

  // { onClearInterval }
  export default function Dashboard(){
    const navigate = useNavigate();

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isLoggedIn, setLoggedIn] = useState(null);
    const [userRole, setUserRole] = useState('');
    const [userId, setUserId] = useState('');
    const userRoleRef = useRef('')
    const userIdRef = useRef('');

      useEffect(()=>{
        /* check account type */
        // axios.post('https://docuquest-swu.swucite.tech/api_drts/checkAccountType.php', {}, {withCredentials: true})
        // .then((res)=>{  
        //   setUserRole(res.data.msgRole);
        //   console.warn("found role: ", res.data.msgRole);   
        // })
        // .catch((err)=>{
        //   console.error("ERROR: This is not a real account! REASON: ", err);

        // })
        const checkSession = () => {
          axios
            .post("https://docuquest-swu.swucite.tech/api_drts/checkSession.php", {}, { withCredentials: true })
            .then((res) => {
              if (res.data.status === 1) {
                setLoggedIn(true);
                setUserRole(res.data.role);
                setUserId(res.data.id);
                userIdRef.current = res.data.id;
                userRoleRef.current = res.data.role;
              } else {
                //console.warn("Session error:", res.data.message);
                setLoggedIn(false);
                navigate('/start');
              }
            })
            .catch(() => {
              setLoggedIn(false);
              navigate("/login");
            });
        };

        checkSession();
        /* check every 4 seconds if user is active or deactivated */
        const interval = setInterval(() => {
          checkSession();

          axios.post('https://docuquest-swu.swucite.tech/api_drts/checkStatusUser.php', {id: userIdRef.current}, { withCredentials: true } )
          .then((res) => {
            // console.warn("is user active or deactivated? ", res.data);
            if (res.data.status !== 1) {
              setLoggedIn(false);
              navigate('/logout');
            }
          })
          .catch((err) => {
            setLoggedIn(false);
            navigate('/logout');
          })
        }, 4000); // Check every 4 seconds

        return () => clearInterval(interval); // Cleanup on component unmount
      }, [navigate])

      if (isLoggedIn === null) {
        return <div>Loading...</div>;
      }

      return (
        <SidebarStateContext.Provider value={{ isSidebarOpen, setIsSidebarOpen }}>
          <div className='Dashboard'>
              <Sidebar>
              <Routes>
                  {/* TODO <PrivateRoute element={Overview} role={userRole}/> */}
                  <Route path='/overview/*' element={<Overview/>}>
                      <Route path='main/' element={<OviewMain/>} />
                      <Route path='tasks/' element={<OviewTasks/>} />
                      <Route path='team/' element={<OviewTeam/>} />
                      <Route path='reports/' element={<OviewReports/>} />
                      <Route path='documents/*' element={<Documents/>} />
                      <Route path='transactions/*' element={<Transactions/>} />
                      <Route path='manage/requests' element={<MgmtRequests/>} />
                  </Route>

                  <Route path='/policy' element={<InfoPoliciesGuidelines/>} />
                  <Route path='/about' element={<InfoAbout/>} />

                  {/* quicknavs */}
                  <Route path='/profile/:accountId' element={<SingleUser/>} />
                  <Route path='/settings' element={<MenuSettings/>} />
                  {/* analytics accordion */}
                  <Route path='/analytics/employees' element={<NltxEmployees/>} />
                  <Route path='/analytics/clients' element={<NltxClients/>} />
                  <Route path='/analytics/transactions' element={<NltxTransactions/>} />
                  <Route path='/analytics/documents' element={<NltxDocuments/>} />
                  {/* client modules */}
                  
                  <Route path='/manage/requests' element={<MgmtRequests/>} />
                  
                  {/* <Route path='/tracking/requests' element={<TrackRequests/>} /> */}
                  {/* employee and admin CRUD pages */}
                  <Route path='/manage/users' element={<MgmtUsers/>} />
                  <Route path='/manage/:accountId' element={<SingleUser/>} />
                  <Route path='/respond/:refNumber' element={<SingleRequest/>} />
                  <Route path='/logout' element={<Logout/>} />

                  <Route path='/*' element={<Navigate to={'/overview'} />} />
              </Routes>
              </Sidebar>
              
              <Routes>
                  <Route path='/logout' element={<Logout/>} />
              </Routes>
          </div>
        </SidebarStateContext.Provider>
      )
  }